export default __webpack_public_path__ + "static/media/logo.372aaa4c.png";